import React from 'react';
import { observer } from 'mobx-react';
import { getConf, readConfObject, } from '@jbrowse/core/configuration';
import CascadingMenu from '@jbrowse/core/ui/CascadingMenu';
import { getSession, getContainingView } from '@jbrowse/core/util';
import { IconButton, Paper, Typography, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { bindTrigger, bindPopover, usePopupState, } from 'material-ui-popup-state/hooks';
// icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DragIcon from '@mui/icons-material/DragIndicator';
import CloseIcon from '@mui/icons-material/Close';
const useStyles = makeStyles()(theme => ({
    root: {
        background: alpha(theme.palette.background.paper, 0.8),
        '&:hover': {
            background: theme.palette.background.paper,
        },
        transition: theme.transitions.create(['background'], {
            duration: theme.transitions.duration.shortest,
        }),
    },
    trackName: {
        margin: '0 auto',
        width: '90%',
        fontSize: '0.8rem',
        pointerEvents: 'none',
    },
    dragHandle: {
        cursor: 'grab',
        color: '#135560',
    },
    dragHandleIcon: {
        display: 'inline-block',
        verticalAlign: 'middle',
        pointerEvents: 'none',
    },
    iconButton: {
        padding: theme.spacing(1),
    },
}));
function getTrackName(track, session) {
    const trackName = getConf(track, 'name');
    if (getConf(track, 'type') === 'ReferenceSequenceTrack') {
        const asm = session.assemblies.find(a => a.sequence === track.configuration);
        return (trackName ||
            (asm
                ? `Reference Sequence (${readConfObject(asm, 'name')})`
                : 'Reference Sequence'));
    }
    return trackName;
}
const TrackLabel = React.forwardRef(({ track, className }, ref) => {
    var _a;
    const { classes, cx } = useStyles();
    const view = getContainingView(track);
    const session = getSession(track);
    const trackConf = track.configuration;
    const trackId = getConf(track, 'trackId');
    const trackName = getTrackName(track, session);
    const popupState = usePopupState({
        popupId: 'trackLabelMenu',
        variant: 'popover',
    });
    const onDragStart = (event) => {
        const target = event.currentTarget;
        if (target.parentNode) {
            const parent = target.parentNode;
            event.dataTransfer.setDragImage(parent, 20, 20);
            view.setDraggingTrackId(track.id);
        }
    };
    const items = [
        ...(((_a = session.getTrackActionMenuItems) === null || _a === void 0 ? void 0 : _a.call(session, trackConf)) || []),
        ...track.trackMenuItems(),
    ].sort((a, b) => (b.priority || 0) - (a.priority || 0));
    return (React.createElement(Paper, { ref: ref, className: cx(className, classes.root) },
        React.createElement("span", { draggable: true, className: classes.dragHandle, onDragStart: onDragStart, onDragEnd: () => view.setDraggingTrackId(undefined), "data-testid": `dragHandle-${view.id}-${trackId}` },
            React.createElement(DragIcon, { className: classes.dragHandleIcon, fontSize: "small" })),
        React.createElement(IconButton, { onClick: () => view.hideTrack(trackId), className: classes.iconButton, title: "close this track", color: "secondary" },
            React.createElement(CloseIcon, { fontSize: "small" })),
        React.createElement(Typography, { variant: "body1", component: "span", className: classes.trackName }, trackName),
        React.createElement(IconButton, { ...bindTrigger(popupState), className: classes.iconButton, color: "secondary", "data-testid": "track_menu_icon", disabled: !items.length },
            React.createElement(MoreVertIcon, { fontSize: "small" })),
        React.createElement(CascadingMenu, { ...bindPopover(popupState), onMenuItemClick: (_, callback) => callback(), menuItems: items, popupState: popupState })));
});
export default observer(TrackLabel);
//# sourceMappingURL=TrackLabel.js.map